/**
 * App Reducers
 */
import { combineReducers } from 'redux';
import settings from './settings';
import authUserReducer from './AuthUserReducer';
import roleReducer from './master/RoleReducer';
import mskReducer from './sportsscience/MskReducer';
import commonReducer from './CommonReducer';
import academyReducer from './master/AcademyReducer';
import academyprogramReducer from './master/AcademyProgramReducer';
import menuAccessReducer from './master/MenuAccessReducer';
import workflowReducer from './master/WorkflowReducer';
import pginclusionReducer from './master/ProgramInclusionReducer';
import scReducer from './sportsscience/SCReducer';
import memberReducer from './master/memberReducer';
import mskVisualisationReducer from './sportsscience/mskVisualisationReducer';
import mskpostureReducer from './sportsscience/MskPostureReducer';
import scvisualisationReducer from './sportsscience/SCVisualisationReducer';
import ssteam from './sportsscience/SSTeamReducer';
import findingchart from './sportsscience/mskfindchartReducer';
import injurychart from './sportsscience/InjuryChartReducer';
import travelform from './travelr/TravelFormReducer';
import travelcalendar from './travelr/TravelCalendarReducer';
import travelreport from './travelr/TravelReportReducer';
import cumulativereport from './travelr/CumulativeReportReducer';
import practiceschedule from './golf/practiceScheduleReducer';
import practicedrill from './golf/practicsDrillReducer';
import visitors from './travelr/VisitorReducer';
import tournamentlist from './golf/tournamentListReducer';
import tournamentprocess from './golf/tournamentProcessReducer';
import playerintervention from './golf/playerInterventionReducer';
import fsirons from './golf/technologyreport/fsIronsReducer';
import fsdriver from './golf/technologyreport/fsDriverReducer';
import tqwedgeplay from './golf/technologyreport/wedgePlayReducer';
import contractstudent from './contract/StudentListReducer';
import ProgramInclusions from './contract/programInclusionReducer'
import contractDashboard from './contract/contractDashboardReducer';
import studentdownload from './contract/studentDownloadReducer';
import studentid from './contract/studentIDReducer'
import contractrenewal from './contract/ContractRenewalReducer';
import samlabreport from './golf/technologyreport/samLabReportReducer';
import captoreport from './golf/technologyreport/captoputtingReducer';
import launchreport from './golf/technologyreport/launchMonitorReducer';
import hackmotionreport from './golf/technologyreport/hackMotionReducer';
import speedcheck from './golf/technologyreport/speedCheckReducer';
import courseintervention from './golf/workinprocess/courseInterventionReducer';
import rangeputting from './golf/rangeintervention/puttingReducer';
import rangelonggame from './golf/rangeintervention/longGameReducer';
import rangeshortgame from './golf/rangeintervention/shortGameReducer';
import octbunker from './golf/oncoursetest/bunkerPlayReducer';
import octwedge from './golf/oncoursetest/wedgePlayReducer';
import octshortgame from './golf/oncoursetest/shortGameReducer';
import octapproach from './golf/oncoursetest/approachReducer';
import octdriving from './golf/oncoursetest/drivingReducer';
import ortchipping from './golf/onrangetest/chippingReducer';
import ortbunker from './golf/onrangetest/bunkerReducer';
import ortwedgeplay from './golf/onrangetest/wedgeReducer';
import ortshortgame from './golf/onrangetest/shortgameReducer';
import ortiron from './golf/onrangetest/ironReducer';
import ortdriving from './golf/onrangetest/drivingReducer';
import ortlonggame from './golf/onrangetest/longgameReducer';
import puttperformance from './golf/putt/puttperformanceReducer';
import puttbdfive from './golf/putt/puttbdFiveReducer';
import puttbdten from './golf/putt/puttdbTenReducer';
import puttbdfifteen from './golf/putt/puttdbFifteenReducer';
import puttbdhundred from './golf/putt/puttdbHundredReducer';
import ocscoring from './golf/oncoursetest/scoringReducer';
import tournamentscore from './golf/tournamentScoreReducer';

const reducers = combineReducers({
   settings,   
   authUser: authUserReducer,
   mostlyused : commonReducer,
   role:roleReducer,
   academy:academyReducer, 
   menuaccess:menuAccessReducer,
   academyprogram:academyprogramReducer,
   workflow:workflowReducer,
   mskassessment:mskReducer,
   scassessment:scReducer,
   programinclusion:pginclusionReducer,
   members:memberReducer,
   mskvisualisation:mskVisualisationReducer,
   mskposture:mskpostureReducer,
   scvisualisation:scvisualisationReducer,
   ssteam:ssteam,
   findingchart:findingchart,
   injurychart:injurychart,
   travelform:travelform,
   travelcalendar:travelcalendar,
   travelreport:travelreport,
   cumulativereport:cumulativereport,
   practiceschedule:practiceschedule,
   practicedrill:practicedrill,
   visitors:visitors,
   tournamentlist:tournamentlist,
   tournamentprocess:tournamentprocess,
   playerintervention:playerintervention,
   fsirons:fsirons,
   fsdriver:fsdriver,
   tqwedgeplay:tqwedgeplay,
   contractstudent:contractstudent,
   ProgramInclusions:ProgramInclusions,
   contractDashboard:contractDashboard,
   studentdownload:studentdownload,
   studentid:studentid,
   contractrenewal:contractrenewal,
   samlabreport:samlabreport,
   captoreport:captoreport,
   launchreport:launchreport,
   hackmotionreport:hackmotionreport,
   speedcheck:speedcheck,
   courseintervention:courseintervention,
   rangeputting:rangeputting,
   rangelonggame:rangelonggame,
   rangeshortgame:rangeshortgame,
   octbunker:octbunker,
   octwedge:octwedge,
   octshortgame:octshortgame,
   octapproach:octapproach,
   octdriving:octdriving,
   ortchipping:ortchipping,
   ortbunker:ortbunker,
   ortwedgeplay:ortwedgeplay,
   ortshortgame:ortshortgame,
   ortiron:ortiron,
   ortdriving:ortdriving,
   ortlonggame:ortlonggame,
   puttperformance:puttperformance,
   puttbdfive:puttbdfive,
   puttbdten:puttbdten,
   puttbdfifteen:puttbdfifteen,
   puttbdhundred:puttbdhundred,
   ocscoring:ocscoring,
   tournamentscore:tournamentscore
});

export default reducers;
